module.exports = __webpack_public_path__ + "static/media/98gal14.80124e38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/98gal/98gal14.jpg
// module id = 245
// module chunks = 0